import {z} from 'zod';

import {translations} from 'presentation/translations-new';
import {IDENTIFIER_LENGTH, clearLoginMask, validateCPF} from 'presentation/utils';

const {invalidLogin} = translations['pt-br'].publicFlow.errors;

export const formSchema = z.object({
	login: z
		.string()
		.trim()
		.transform(val => val.replace(/\s/g, ''))
		.transform(val => clearLoginMask(val))
		.refine(
			val => {
				if (val.length === IDENTIFIER_LENGTH.cpf) {
					return validateCPF(val);
				}
				return true;
			},
			{message: invalidLogin},
		),
});

export type IFormData = z.infer<typeof formSchema>;
